const e = "UserService";
export {
  e as USER_SERVICE
};
